import FormattedName from 'I18n/components/FormattedName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalUserFormattedName(props) {
  const {
    approvalUser
  } = props;
  const {
    isActive
  } = approvalUser;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedName, {
      givenName: approvalUser.firstName,
      familyName: approvalUser.lastName,
      email: approvalUser.email
    }), !isActive && /*#__PURE__*/_jsx("span", {
      className: "m-left-1",
      style: {
        fontWeight: 'normal'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalUserFormattedName.deactivated"
      })
    })]
  });
}
export default ApprovalUserFormattedName;